angular.module("transactionTableDigitalSign.components", [])
    .component("transactionTableDigitalSign", {
        templateUrl: "ng/components/transactionTableDigitalSign/transactionTableDigitalSign.view.html",
        bindings: {
            filter: '<'
        },
        controller: TableDigitalSignController,
        controllerAs: "tableDigitalSignCtrl"
    });

function TableDigitalSignController(
    $configService,
    $userService,
    $contractService,
    $arcService,
    FactoryObj,
    $location
) {
    var self = this;

    self.$onInit = function () {
        self.loaderFirma = []
        self.$contractService = $contractService;
        self.filter = self.filter;
        self.getAllSignedContracts(self.filter);
        self.user = $configService.getUser();
    }

    self.$onChanges = function (changed) {
        if (typeof changed.filter.currentValue != "undefined") {
            self.getAllSignedContracts(changed.filter.currentValue)
        }
    }


    self.getAllSignedContracts = function (filter) {

        $contractService.getAllSignedContracts(filter)
            .then(function (list) {
                self.sortedContractList = list
                    .filter(function (contract) {
                        return contract.signedStatus < 10
                    });
                self.contractList = self.sortedContractList;
            })
    }

    self.selectContract = function (contract, index) {
        self.loaderFirma[index] = true;
        console.log(contract);
        $arcService.startUserSignature(contract.dossierId, contract.cfCustomer)
            .then(function (response) {

                switch (response.startingPointType) {


                    case "EXTERNAL":
                        window.open(response.dossierUrl, "_self");
                        break;

                    default:
                        contract.appContract = {
                            idContract: contract.idContract
                        }
                        FactoryObj.selectedContract = contract;
                        $location.path("/signedContracts");
                        break;
                }
                self.loaderFirma[index] = false;
            })
            .catch(function (error) {
                console.log(error);
                self.loaderFirma[index] = false;
            })
    }

    self.customerListSortFunction = function (headerName, headerOrder) {
        self.customerListSortKey = headerName; //set the sortKey to the param passed
        if (headerOrder == "up") {
            self.customerListReverse = false;
        } else {
            self.customerListReverse = true;
        }
    };

    self.hideSortArrow = function (headerName, headerOrder) {
        if (self.customerListSortKey == headerName) {
            if (headerOrder == "up" && self.customerListReverse == false) {
                return true;
            }
            if (headerOrder == "down" && self.customerListReverse == true) {
                return true;
            }
        }
        return false;
    };

}

